'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridClassNames: function() {
        return dataGridClassNames;
    },
    useDataGridStyles_unstable: function() {
        return useDataGridStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableStylesstyles = require("../Table/useTableStyles.styles");
const dataGridClassNames = {
    root: 'fui-DataGrid'
};
const useDataGridStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableStylesstyles.useTableStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridClassNames.root, state.root.className);
    return state;
};
